import { id_ce } from "../object_identifiers";
import { KeyIdentifier } from "./authority_key_identifier";
export const id_ce_subjectKeyIdentifier = `${id_ce}.14`;
export class SubjectKeyIdentifier extends KeyIdentifier {
}
